export default __webpack_public_path__ + "static/media/Anne_Laure_Perrot.f0869db1.jpg";